<template>
	<div class="open_ssl">
		<slot></slot>
		<wx-open-launch-weapp id="launch-webapp" :username="username" :path="path" @launch="onLaunch">
			<script type="text/wxtag-template">
				<style>
					.btn{
						width: 100%;
						height: 200px;
						opacity: 0;
					}
				</style>
				<button class="btn"></button>
			</script>
		</wx-open-launch-weapp>
	</div>
</template>

<script>
export default {
    name: 'OpenSsl',
    props: {
        id: {
            type: String,
            default: 'button'
        },
        username: {
            type: String,
            default: ''
        },
        path: {
            type: String,
            default: ''
        },
        configParams: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        onLaunch () {
            this.$emit('onClick')
        }
    }
};
</script>
<style scoped lang="less">
.open_ssl {
	position: relative;
	overflow: hidden;
	flex: 1;
	#launch-webapp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}
}
</style>
